import { type NotificationBadges, createNotificationBadges } from 'models';
import { useQuery } from 'query';
import { getNotificationsPanelCounts } from '../services';
import { getBadgesQueryKey } from './keys';

export const useNotificationBadgesQuery = () =>
  useQuery<NotificationBadges>({
    async queryFn() {
      const { data } = await getNotificationsPanelCounts();
      return createNotificationBadges(data);
    },
    queryKey: getBadgesQueryKey(),
    refetchOnMount: 'always',
  });
